import { Component, ContentChildren, QueryList, AfterContentInit, TemplateRef, ContentChild } from '@angular/core';
import { TabComponent } from '../tab/tab.component';

@Component({
  selector: 'app-tabs',
  templateUrl: './tabs.component.html',
  styleUrl: './tabs.component.scss'
})
export class TabsComponent implements AfterContentInit {
  @ContentChildren(TabComponent) tabs!: QueryList<TabComponent>;
  activeTab!: TabComponent;

  ngAfterContentInit() {
    this.activeTab = this.tabs.first;
  }

  selectTab(tab: TabComponent): void {
    this.activeTab = tab;
  }
}
